import { render, staticRenderFns } from "./common.vue?vue&type=template&id=a5d49566&scoped=true"
import script from "./common.vue?vue&type=script&lang=js"
export * from "./common.vue?vue&type=script&lang=js"
import style0 from "./common.vue?vue&type=style&index=0&id=a5d49566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d49566",
  null
  
)

export default component.exports